module.exports = __webpack_public_path__ + "static/media/female_toilet.c5d27e03.svg";